<template>
  <section class="page page__login">
    <div class="container">
      <v-row align="center" justify="center">
        <v-spacer />
        <v-col cols="12" xl="8" lg="8" md="8" sm="8" xs="10">
          <v-card rounded elevation="0" flat>
            <v-img :src="getLogo()" aspect-ratio="1" max-height="150" contain />
          </v-card>
          <br />
          <v-card rounded class="email-bg" elevation="0" flat>
            <p>{{ this.$i18n.t("email.emailWelcomeMessage") }}</p>
            <v-form ref="form" v-model="valid" @submit.prevent="registerEmail">
              <div class="col-form">
                <v-text-field id="email-field" class="col-form__item" v-model="email" :rules="emailRules"
                  :placeholder="$i18n.t('email.placeholder')" autocomplete="off" :disabled="loading" />
                <v-row no-gutters>
                  <v-spacer />
                  <v-checkbox v-model="acceptedTerms" :rules="termRules" :disabled="loading" color="primary">
                    <template v-slot:label>
                      <i18n path="email.terms.main" tag="div" class="terms">
                        <a :href="$i18n.t('email.terms.terms.url')" target="_blank" @click.stop>
                          {{ $i18n.t("email.terms.terms.text") }}
                        </a>
                        <a :href="$i18n.t('email.terms.privacy.url')" target="_blank" @click.stop>
                          {{ $i18n.t("email.terms.privacy.text") }}
                        </a>
                        <a :href="$i18n.t('email.terms.protection.url')" target="_blank" @click.stop>
                          {{ $i18n.t("email.terms.protection.text") }}
                        </a>
                      </i18n>
                    </template>
                  </v-checkbox>
                  <v-spacer />
                </v-row>
                <br />
                <v-btn id="email-submit" :class="{ 'btn-finish': true, }" :loading="loading" :disabled="!valid || loading"
                  type="submit" rounded color="primary">
                  {{ $i18n.t("email.emailButton") }}
                </v-btn>
              </div>
            </v-form>
          </v-card>
        </v-col>
        <v-alert v-if="errorMessage" :value="errorMessage" type="error">{{ errorMessage }}</v-alert>
        <v-spacer />
      </v-row>
    </div>
  </section>
</template>

<script>
/* eslint-disable arrow-parens, global-require, no-restricted-globals */
export default {
  name: "Email",
  data() {
    return {
      valid: false,
      email: null,
      referral: null,
      loading: false,
      errorMessage: null,
      acceptedTerms: false,
      emailRules: [
        v => !!v || this.$i18n.t("forms.formMustComplete"),
        v =>
          // eslint-disable-next-line implicit-arrow-linebreak
          /^[a-zA-Z0-9.\-_+]+@[a-zA-Z0-9.\-_+]+\.[a-zA-Z0-9.\-_+]+$/.test(v) || this.$i18n.t("forms.formEmail"),
      ],
      termRules: [v => !!v || this.$i18n.t("email.terms.wrong")],
    };
  },
  methods: {
    getLogo() {
      if (location.href.includes("brolly")) {
        return require("@/assets/brolly.png");
      }
      if (location.href.includes("relif")) {
        return require("@/assets/relif.svg");
      }
      return require("@/assets/ameris.png");
    },
    async registerEmail() {
      this.loading = true;
      this.errorMessage = null;
      this.$store.commit("cleanState");
      const body = {
        email: this.email.trim(),
      };
      if (this.referral) {
        body.referral = this.referral.trim();
      }
      try {
        const response = await this.axios.post(`${process.env.VUE_APP_BACKEND}email`, body, {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        });
        this.$store.commit("updateExists", response.data.exists);
        this.$store.commit("updateEmail", { email: response.data.email });
        if (response.data.exists) {
          this.loading = false;
          if (location.href.includes("brolly")) {
            window.location.href = this.$i18n.t("email.redirect.brolly", { email: this.email.trim() });
          } else if (location.href.includes("relif")) {
            window.location.href = this.$i18n.t("email.redirect.relif");
          } else {
            window.location.href = this.$i18n.t("email.redirect.ameris");
          }
          return;
        }
        if (response.data.code === 610) {
          this.$store.commit("updateSession", { session: response.data.session });
          this.$store.commit("updateFormStep", { step: 7 });
          this.loading = false;
          this.$router.push("success");
          return;
        }
        if (response.data.code === 620) {
          this.$store.commit("updateSession", { session: response.data.session });
          this.$store.commit("updateFormStep", { step: 6 });
          this.loading = false;
          this.$router.push("bankform");
          return;
        }
        // eslint-disable-next-line no-undef
        heap.identify(this.email.trim());
        this.$store.commit("updateSession", { session: response.data.session });
        this.$store.commit("updateFormStep", { step: 1 });
        this.$router.push("userform");
      } catch (err) {
        this.loading = false;
        throw err;
      }
    },
  },
  beforeMount() {
    if (this.$route.query.email) {
      this.email = this.$route.query.email;
    }
    if (this.$route.query.referral) {
      this.referral = this.$route.query.referral;
    }
  },
  mounted() { },
};
</script>

<style scoped>
.terms {
  font-size: 11px;
}

.email-bg {
  padding: 15px;
}
</style>
